import styled from 'styled-components';

/** Standard slide layout: flex column, 1.25 rem gap, full height. */
export const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  height: 100%;
  flex: 1;
  min-height: 0;
`;

/** Centred text wrapper used above the main slide content. */
export const SlideHeader = styled.div`
  text-align: center;
`;

/** Primary slide heading (h3, 17px / 700, #111827). */
export const SlideTitle = styled.h3`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #111827;
`;

/** Secondary slide description line (14px / 400, #4B5563). */
export const SlideSubtitle = styled.p`
  margin: 0.35rem 0 0;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #4B5563;
`;

/** Centred placeholder shown while loading or when no data is available. */
export const EmptyState = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #9CA3AF;
  text-align: center;
  padding: 2rem;
`;

export const HeroHeadline = styled.h3`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #414141;
  line-height: 1.15;
`;

export const HeroLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  margin: 0.75rem 0 0 0;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  padding-bottom: 0.75rem;
`;


export const SectionHeading = styled.h4`
  margin: 1.0rem 0 0.75rem;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #414141;
  border-left: 10px solid rgba(255, 255, 255, 0.45);
  padding-left: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  align-self: flex-start;
  line-height: 1.7;
`;

export const SectionText = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #414141;
  line-height: 1.75;
  padding-left: 1.5rem;
`;

export const HeroBody = styled.p`
  margin: 0.5rem 0 0;
  font-family: 'Poppins', sans-serif;
  font-size: clamp(14px, 2vh, 14px);
  font-weight: 400;
  color: #475569;
  line-height: 1.5;
  max-width: 90ch;
`;

export const HeroBanner = styled.div`
  background: rgba(255, 255, 255);
  border-radius: 1rem;
  padding: 1.1rem 2.25rem;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  flex: 1;
  margin: 10px 20px 20px;
  min-height: auto;
  height: auto;

  @media (max-width: 600px) and (orientation: portrait) {
    margin: 8px 8px 12px;
    padding: 0.9rem 0.85rem;
  }
  `;

export const BannerDecoClip = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 1rem;
  overflow: hidden;
  pointer-events: none;
  &::before {
    content: '';
    position: absolute;
    top: -30px;
    right: -30px;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 40%;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const HeroStrong = styled.strong`
  color: #414141;
  font-weight: 600;
`;
